import { IPageLineDisplay } from "../production/models/lines/page-line-display";
import { BaseModuleState } from "./_BaseModuleState";

export class ProductionModuleState extends BaseModuleState {

    // Tab States
    public selectedPlanningTab : string | undefined = undefined;

    public selectedLine : IPageLineDisplay|undefined = undefined;

}
